import styles from "./HowItWorks.module.css"
import image from "../../assets/images/sharebackground.webp"
import howitworksimg from "../../assets/images/howitworks.svg"
import Button from "../Button";
import { Link } from "react-router-dom";

const HowItWorks =()=>{

    return (
      <section className={`height ${styles.main}`}>
        <img className={styles.bgHaze} src={image} alt="" aria-hidden="true" />
        <div className={styles.content}>
          <div className={styles.imgCont}>
          <img className={styles.imgbg} src={image} alt="how-it-works" />
          <img className={styles.img} src={howitworksimg} alt="sign" />
          </div>
          <h2 className="h2-bold">How it works</h2>
          <p className="h4-medium">
            We film distortion grids following <a
              href="https://matchmovemachine.com/howto"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.blueLink}
            >the guide</a> and then we create assets for your workflow.
          </p>
          <p className="h4-medium">
            If you spot this icon on a product, it means it was produced and
            <strong> quality-checked</strong> in our Matchmove machine studio — so the
            quality of the purchased asset is guaranteed. If it doesn’t work as intended, we offer a
            <strong> money-back guarantee.</strong>
          </p>
          <p className="h4-medium">
            Assets without this mark are <strong>free</strong>, user-uploaded files. We can’t
            guarantee they will perform exactly as expected. Discover more about our
            process for preparing and testing distortion grids and presets.
          </p>
          <div className={styles.btn}>
            <Link to="/how-it-works">
              <Button label="See more" iconType="arrowRight" />
            </Link>
          </div>
        </div>
      </section>
    );
}

export default HowItWorks